<template>
  <div id="footer">
    <ul class="footer-content">
      <li class="li-item left">
        <p class="title">关于优我科华</p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('about')"
          >了解我们</span>
        </p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('about',4040)"
          >企业文化</span>
        </p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('develop',3525)"
          >加入我们</span>
        </p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('contact')"
          >联系我们</span>
        </p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('about',4730)"
          >合作伙伴</span>
        </p>
      </li>
      <li class="li-item left">
        <p class="title">产品体系</p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('home',1370)"
          >产品服务</span>
        </p>
        <p class="a-link">
          <span
            class="a"
            @click="handleLink('home',1370)"
          >数据服务</span>
        </p>
      </li>
      <li class="li-item left">
        <p class="title">法律政策</p>
        <p class="a-link">
          <router-link
            :to="{path:'/server'}"
            target="_blank"
          >服务条款
          </router-link>
          <!-- <span class="a" @click="handleLink('server')">服务条款</span> -->
        </p>
        <p class="a-link">
          <router-link
            :to="{path:'/privacy'}"
            target="_blank"
          >隐私声明
          </router-link>
          <!-- <span class="a" @click="handleLink('privacy')">隐私声明</span> -->
        </p>
        <p class="a-link">
          <router-link
            :to="{path:'/rule'}"
            target="_blank"
          >阳光准则
          </router-link>
          <!-- <span class="a" @click="handleLink('rule')">阳光准则</span> -->
        </p>
      </li>
      <li
        class="li-item right"
        style="width: 533px;"
      >
        <div class="footer-logo right">
          <img
            src="@/assets/image/logo.png"
            alt=""
          />
        </div>
        <div class="footer-desc">
          <p>Copyright © 2017-2021 YOUWOKEHUA Tech. All Rights Reserved</p>
          <p>优我科华 版权所有</p>
        </div>
      </li>
    </ul>
    <div class="line"></div>
    <p class="record">
      优我科华 版权所有 <a
      href="https://beian.miit.gov.cn"
      target="_blank"
    >陕ICP备18007850号-1</a></p>

  </div>
</template>


<script>
export default {
  data() {
    return {
      msg: "ads"
    }
  }, methods: {
    handleLink(_path, _val) {
      this.$router.push({
        path: '/' + _path,
        query: {
          href: _val,
          key: new Date().getTime()
        }
      })
    }
  },
}

</script>
<style lang='scss' scoped>
$width: 1200px;

#footer {
  padding: 80px 0px 40px;
  background: rgba(248, 248, 248, 1);
  text-align: center;
  font-size: 14px;
  line-height: 16px;

  .line {
    width: $width;
    height: 1px;
    margin: 0 auto;
    background: rgba(0, 0, 0, 0.05);
  }

  .record {
    padding-top: 24px;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.65);

    a {
      text-decoration: none;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  /* color: rgba(255, 255, 255, 0.45); */
  .footer-content {
    width: $width;
    height: 192px;
    margin: 0 auto;
    margin-bottom: 80px;

    .li-item {
      width: 200px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.65);
      text-align: left;

      .title {
        font-size: 20px;
        padding-bottom: 16px;
      }

      .a-link {
        font-size: 16px;
        margin-top: 16px;

        .a {
          color: rgba(0, 0, 0, 0.65);
          cursor: pointer;

          &:hover {
            color: rgba(0, 0, 0, 0.85);
          }
        }

        a {
          text-decoration: none;
          color: rgba(0, 0, 0, 0.65);

          &:hover {
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }

      .footer-logo {
        width: 180px;
        height: 58px;
      }

      .footer-desc {
        padding-top: 82px;

        p {
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.45);
          font-size: 16px;
          text-align: right;
          line-height: 20px;
        }
      }
    }

    .right {
      width: 233px;
    }
  }
}
</style>
